import Datepicker, { DateValueType, DatepickerType } from 'react-tailwindcss-datepicker';
import TextInput, { TextInputType } from '@components/form/TextInput';

type Props = {
	name: string;
	parentClass?: string;
	className?: string;
	onChange?: (value: DateValueType) => void;
};

export default function DatepickerInput({
	label,
	error,
	disabled,
	labelClass,
	name,
	value,
	parentClass = '',
	asSingle = true,
	useRange = false,
	displayFormat = 'DD-MM-YYYY',
	className = '',
	maxDate,
	onChange,
	...otherProps
}: Props & DatepickerType & TextInputType) {
	return (
		<TextInput
			label={label}
			labelClass={labelClass}
			className={parentClass}
			error={error}
		>
			<Datepicker
				{...otherProps}
				i18n={"id"}
				primaryColor="orange"
				maxDate={maxDate ? maxDate : null}
				disabled={disabled}
				inputId={name}
				inputName={name}
				containerClassName={`relative mt-1 ${className}`}
				inputClassName={`w-full border border-solid focus:outline-teal-500 rounded-lg duration-300 px-3 py-[10px] ${
					error ? 'border-red-500' : ''
				}`}
				asSingle={asSingle}
				useRange={useRange}
				displayFormat={displayFormat}
				value={value}
				onChange={onChange}
			/>
		</TextInput>
	);
}
